module.exports = __webpack_public_path__ + "static/media/mbta-t.475b22ac.png";